import { render, staticRenderFns } from "./SnipeAssetUserAssets.vue?vue&type=template&id=5c891f1f"
import script from "./SnipeAssetUserAssets.js?vue&type=script&lang=js&external"
export * from "./SnipeAssetUserAssets.js?vue&type=script&lang=js&external"
import style0 from "./SnipeAssetUserAssets.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports